import './clipboard-copy.css';
export default {
  "button": "pf-v6-c-button",
  "clipboardCopy": "pf-v6-c-clipboard-copy",
  "clipboardCopyActions": "pf-v6-c-clipboard-copy__actions",
  "clipboardCopyActionsItem": "pf-v6-c-clipboard-copy__actions-item",
  "clipboardCopyExpandableContent": "pf-v6-c-clipboard-copy__expandable-content",
  "clipboardCopyGroup": "pf-v6-c-clipboard-copy__group",
  "clipboardCopyText": "pf-v6-c-clipboard-copy__text",
  "clipboardCopyToggleIcon": "pf-v6-c-clipboard-copy__toggle-icon",
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "expanded": "pf-m-expanded",
    "inline": "pf-m-inline",
    "block": "pf-m-block",
    "truncate": "pf-m-truncate",
    "code": "pf-m-code",
    "plain": "pf-m-plain"
  }
};